import { render, staticRenderFns } from "./PhieuCocSaiFormat.vue?vue&type=template&id=15cf13ee"
import script from "./PhieuCocSaiFormat.vue?vue&type=script&lang=js"
export * from "./PhieuCocSaiFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports